export const isItem = (itemA, itemB) => {
    const { name: itemA_name, params: itemA_params } = itemA.route;
    const { name: itemB_name, params: itemB_params } = itemB.route;
    return itemA_name === itemB_name
        && itemA_params.uuid === itemB_params.uuid;
};

export const isSubItem = (itemA, itemB) => {
    const { name: itemA_name, params: itemA_params, query: itemA_query } = itemA.route;
    const { name: itemB_name, params: itemB_params, query: itemB_query } = itemB.route;
    return itemA_name === itemB_name
        && itemA_params.uuid === itemB_params.uuid
        && itemA_query.id === itemB_query.id;
};
